var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocal(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none",
    viewBox: "0 0 40 40",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 18v10c0 1.534 1.34 2.778 3 2.778h14c1.66 0 3-1.244 3-2.778V18m5-2.5L20.5 3l-15 12.5M38 39.25c-5.49-3.563-10.27-5.028-17.5-5-7.23.029-12.01 1.437-17.5 5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 23l-4.26-4.233c-.77-.731-.96-1.847-.47-2.772.36-.69 1.05-1.172 1.85-1.296.8-.124 1.61.126 2.18.672l.7.662.7-.663a2.585 2.585 0 012.18-.672c.8.123 1.49.606 1.85 1.296.49.924.3 2.04-.47 2.772L20.5 23z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5 3h5v5"
  })));
}
export default SvgLocal;